/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const AppPanelBox = styled.div`
  display: ${({ isLoading }) => (isLoading ? 'flex' : 'grid')};
  justify-content: ${({ isLoading }) => (isLoading ? 'center' : 'unset')};
  align-items: ${({ isLoading }) => (isLoading ? 'center' : 'unset')};
  grid-template-columns: auto auto 1fr auto auto auto auto;
  gap: 16px;
  width: 100%;
  min-height: 82px;
  background-color: ${({ isLoading }) => (isLoading ? 'white' : `${Palette.PrimaryGray._000}`)};
  border: 1px solid ${Palette.PrimaryGray._200};
  border-radius: 4px;
  margin-bottom: 16px;
  padding: ${({ isLoading }) => (isLoading ? '0' : '16px')};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;

export const BackArrow = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin: auto 12px auto 8px;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    transform: rotate(180deg);
    fill: ${Palette.PrimaryGray._500};
  }

  svg:hover {
    fill: ${Palette.Primary._500};
    background-color: ${Palette.PrimaryGray._100};
  }
`;

export const Separator = styled.div`
  border-right: 1px solid ${Palette.PrimaryGray._200};
`;

export const NameAndIcon = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 4px;
  color: ${Palette.PrimaryGray._900};
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
`;

export const Status = styled.p`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin-left: -10px;
`;

export const AppInfoBox = styled.div`
  display: flex;
  gap: 16px;
`;

export const MenuIconWrap = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;

  width: auto;
  height: 32px;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const TextContainer = styled.div`
  height: 24px;
  display: flex;
  align-items: flex-end;
  gap: 2px;
  font-size: 14px;
`;

export const BoldText = styled.span`
  font-weight: 500;
  color: ${Palette.PrimaryGray._700};
`;

export const DarkerText = styled.span`
  color: ${Palette.PrimaryGray._700};
`;

export const BoldTextTitle = styled.p`
  font-weight: 500;
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  line-height: 20px;
`;

export const TextIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-bottom: -4px;

  border-radius: 4px;

  & + & {
    margin-left: -4px;
  }
`;

export const ImageWrap = styled.div`
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  height: 40px;
  width: 40px;
`;

export const MyProgressBar = styled.progress`
  width: 44px;
  height: 4px;
  margin-bottom: 7px;
  -webkit-appearance: none;
  appearance: none;

  ::-webkit-progress-bar {
    background-color: ${Palette.PrimaryGray._200};
  }

  ::-webkit-progress-value {
    background-color: ${({ percents }) => {
      // percents > 0.5
      //   ? `${Palette.Teal._500}`
      //   : percents > 0.2
      //   ? `${Palette.Amber._500}`
      //   : `${Palette.Red._600}`
      if (percents <= 20) return Palette.Teal._500;
      if (percents > 20 && percents <= 70) return Palette.Amber._500;
      if (percents > 70) return Palette.Red._600;
    }}
`;

export const ButtonWrap = styled.div`
  margin-top: 4px;
  margin-left: 8px;
`;

export const CopyWrap = styled.div`
  max-width: calc(100% - 30px);
  flex-shrink: 0;

  & span:nth-of-type(2) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
